export enum MusicId {
	WASTELAND = "WASTELAND",
	CAVES = "CAVES",
	ROBOT_BASE = "ROBOT_BASE",
	BOSS_PLOW = "BOSS_PLOW",
	BOSS_BLACK_HOLE = "BOSS_BLACK_HOLE",
}
